import {CheckpointResult} from './checkpoint-result';

export class Checkpoint {
    id: number;
    platform_id: number;
    responsible_user_id?: number;
    fallback_responsible_user_id?: number;
    url?: string;
    start_date: Date;
    end_date?: Date;
    name: string;

    validate_ssl: number;
    ssl_valid_till?: Date;
    postponed_till?: Date;
    valid_response_code: number;
    warning_response_code?: number;
    level: level;
    retries: number;
    retry_delay: number;
    min_content_size_error: number;
    max_content_size_error: number;
    min_content_size_warning?: number;
    max_content_size_warning?: number;

    timeout: number;
    interval: number;
    valid_checksum?: string;
    min_response_time_error: number;
    max_response_time_error: number;
    min_response_time_warning?: number;
    max_response_time_warning?: number;

    error: boolean;
    warning: boolean;
    save_contents_on_success: boolean;

    external_ip_allowed?: string;

    updated_at: Date;
    deleted_at?: Date;

    checkpoint_results_count?: number;
    checkpoint_result_last_instance?: CheckpointResult;
}

export enum level {
    PRODUCTION = 'production',
    HEALTH = 'health',
    CHECK = 'check',
    ACCEPTANCE = 'acceptance',
}
